var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { computed, inject } from 'vue';
import createAmadeusActionQueryParams from '../lib/createAmadeusActionQueryParams';
import createAmadeusRefxPostBody from '../lib/createAmadeusRefxPostBody';
export default function useAmadeusParams(_a) {
    var _b, _c, _d, _e, _f, _g;
    var itinerariesRef = _a.itinerariesRef, passengerAndCabinClassRef = _a.passengerAndCabinClassRef, promoCodeRef = _a.promoCodeRef, _h = _a.paramsSource, paramsSource = _h === void 0 ? 'amadeus-booking-params' : _h;
    var refxBookingUrl = (_b = inject('amadeus-refx-booking-url')) !== null && _b !== void 0 ? _b : '';
    var amadeusParams = (_c = inject('amadeus-params')) !== null && _c !== void 0 ? _c : {};
    var amadeusExtraParams = (_d = inject(paramsSource)) !== null && _d !== void 0 ? _d : {};
    var amadeusFareFamilies = (_e = inject('amadeus-fare-families')) !== null && _e !== void 0 ? _e : ['CFFECOBIZ', 'CFFBIZ'];
    var amadeusCompanionPricing = (_f = inject('amadeus-companion-pricing')) !== null && _f !== void 0 ? _f : [];
    var preferences = (_g = inject('preferences')) !== null && _g !== void 0 ? _g : {};
    var params = computed(function () {
        if (refxBookingUrl) {
            return createAmadeusRefxPostBody({
                itineraries: itinerariesRef === null || itinerariesRef === void 0 ? void 0 : itinerariesRef.value,
                promoCode: promoCodeRef === null || promoCodeRef === void 0 ? void 0 : promoCodeRef.value,
                passengerAndCabinClass: passengerAndCabinClassRef === null || passengerAndCabinClassRef === void 0 ? void 0 : passengerAndCabinClassRef.value,
                amadeusFareFamilies: amadeusFareFamilies,
                amadeusParams: __assign(__assign({}, amadeusParams), amadeusExtraParams),
                companionPricing: amadeusCompanionPricing,
                preferences: preferences,
            });
        }
        return createAmadeusActionQueryParams({
            itineraries: itinerariesRef === null || itinerariesRef === void 0 ? void 0 : itinerariesRef.value,
            promoCode: promoCodeRef === null || promoCodeRef === void 0 ? void 0 : promoCodeRef.value,
            passengerAndCabinClass: passengerAndCabinClassRef === null || passengerAndCabinClassRef === void 0 ? void 0 : passengerAndCabinClassRef.value,
            amadeusFareFamilies: amadeusFareFamilies,
            amadeusParams: __assign(__assign({}, amadeusParams), amadeusExtraParams),
            companionPricing: amadeusCompanionPricing,
        });
    });
    return params;
}
